<template>
    <b-container>
        <b-row>
            <b-col cols="12" class="py-3 px-0">
                <b-list-group flush>
                    <template v-for="item in notifications">
                        <b-list-group-item @click="update(item.id)" :class="'border-top text-dark'+(item.status === 0 ? ' active cursor-pointer' : '')">
                            <b-row class="row">
                                <b-col cols="auto" align-self="center">
                                    <i class="material-icons text-template-primary">{{ item.icon }}</i>
                                </b-col>
                                <b-col class="pl-0">
                                    <b-row class="mb-1">
                                        <b-col>
                                            <p class="mb-0">{{ item.title }}</p>
                                        </b-col>
                                        <b-col cols="auto" class="pl-0">
                                            <p class="small text-mute text-trucated mt-1">{{ item.date }}</p>
                                        </b-col>
                                    </b-row>
                                    <p class="small text-mute">{{ item.text }}</p>
                                </b-col>
                            </b-row>
                        </b-list-group-item>
                    </template>
                </b-list-group>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
import axios from "axios";

export default {
    name: "Notifications",
    props: [ 'user' ],
    data: () => ({
        notifications: []
    }),
    mounted() {
        this.$emit('loader');
        this.$emit('section', 'notificationspage');
        this.getIni();
    },
    watch: {
        'user.partner'() {
            clearTimeout(this.timeout);
            this.getIni();
        }
    },
    methods: {
        getIni() {
            axios.get('/api/customer/notifications').then((res) => {
                this.notifications = res.data.notifications;
            }).catch(err => {
                this.$root.$bvToast.toast(err.response.data.errors, {
                    title: 'Notificación',
                    headerClass: 'd-none',
                    variant: 'error',
                    toaster: 'b-toaster-top-right',
                    autoHideDelay: 5000,
                    solid: true,
                    appendToast: true
                });
            });
            this.timeout = setTimeout(this.getIni, 180000);
        },
        update(n) {
            let formData = new FormData();

            formData.append('id', n);
            axios.post('/api/customer/notifications/update', formData).then((res) => {
                if (res.data.status === 'success') {
                    this.$emit('notifications');
                    let notifications = this.notifications;
                    for (let i = 0; i < notifications.length; i++) {
                        if (n === notifications[i].id) {
                            notifications[i].status = 1;
                        }
                    }
                    this.notifications = notifications;
                    if (res.data.url) {
                        this.$router.push(res.data.url);
                    }
                }
            }).catch(err => {
                this.$root.$bvToast.toast(err.response.data.errors, {
                    title: 'Notificación',
                    headerClass: 'd-none',
                    variant: 'error',
                    toaster: 'b-toaster-top-right',
                    autoHideDelay: 5000,
                    solid: true,
                    appendToast: true
                });
            });
        }
    },
    destroyed() {
        clearTimeout(this.timeout);
    }
}
</script>

<style scoped>

</style>
